module.exports = __webpack_public_path__ + "static/media/education_img.e00bfabd.jpg";